const DOSI_URL = import.meta.env.VITE_DOSI_URL;
const DOSI_CITIZEN_CONTRACT_ID = import.meta.env.VITE_DOSI_CITIZEN_CONTRACT_ID;

export const myCitizenItemsUrl = `${DOSI_URL}/profile/me/nfts/holding?contractId=${DOSI_CITIZEN_CONTRACT_ID}`;
